import dayjs, { Dayjs } from "dayjs";
import { TFunction } from "i18next";
import * as Yup from "yup";

export const addElementSchema = (t: TFunction) =>
    Yup.object({
        title: Yup.string().required(t("addElement.validator.required")),
        description: Yup.string(),
        category_id: Yup.number().required(t("addElement.validator.required")),
        start_date: Yup.mixed<Dayjs>().required(
            t("addElement.validator.required"),
        ),
        end_date: Yup.mixed<Dayjs>()
            .nullable()
            .test(
                "is-before-or-equal-start",
                t("addElement.validator.end_date_validation"),
                (value, context) => {
                    if (!value) return true;
                    const startDate = context.parent.start_date;
                    if (!startDate) return false;
                    return (
                        dayjs(value).isAfter(dayjs(startDate)) ||
                        dayjs(value).isSame(dayjs(startDate))
                    );
                },
            ),
        parent_id: Yup.number().nullable(),
        border_width: Yup.number().nullable(),
        border_style: Yup.string().nullable(),
        primary_color: Yup.string().nullable(),
        background_color: Yup.string().nullable(),
    });
